import { Box, Button, SxProps } from '@mui/material'
import DownloadIcon from '@mui/icons-material/Download'

type Props = {
  text: string
  onClick: () => void
  iconSize?: string
  sx?: SxProps
}
const EarningsCustomField = ({
  text,
  onClick,
  iconSize = '24px',
  sx
}: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        ...sx
      }}
    >
      {text}
      <Button
        sx={{ minWidth: 'unset', padding: 0 }}
        variant="text"
        onClick={onClick}
      >
        <DownloadIcon
          data-testid="download-icon"
          sx={{ height: iconSize, width: iconSize }}
        />
      </Button>
    </Box>
  )
}

export { EarningsCustomField }
